<section>
    <span id="formHeader">Say Hi!</span>
    <div class="formContainer w-100">
        <span id="formHeadline">Want to discuss a new project?</span>
        <span id="formSubHeadline">Say hello! let's discuss your ideas and make it happen</span>
        <app-form></app-form>
        <a href="#top"><img id="arrowUp" src="./assets/img/arrowUpS.png" alt=""></a>
    </div>

</section>